var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"sky"}),_c('iframe',{attrs:{"src":_vm.url,"frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }